import { startLoading, stopLoading } from "./act_loading"

import { changeLang } from "../../utils"
import { ActionTypes } from "./act_types"
import { fetchAllComFamilies, fetchAllTechFamilies } from "./product-form"
import { fetchTranslations } from "./act_translations"

export const onChangeLang =
  (e: any, { value }: any) =>
  (dispatch: (callback: object) => void) => {
    window.stop()
    changeLang(value)
    window.location.reload()
    // dispatch(startLoading())
    // dispatch(fetchAllComFamilies())
    // dispatch(fetchAllTechFamilies())
    // dispatch({
    //   type: ActionTypes.CHANGE_LANG,
    //   lang: value
    // })
    // dispatch(fetchTranslations())
    // dispatch(stopLoading())
  }
